import _ from 'lodash';
import { MINIMUM_FLEXI_LOAN_AMOUNT, TFormData } from './ApplyFlexiLoanFormView';
import messages from './ApplyFlexiLoanformValidation.messages';
import { intlFormatCurrency } from '@iwIntlProvider/FormattedCurrency';
import { getCountry } from '@iwIntlProvider/CountryProvider';
import { IntlShape } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default ({
    intl,
    values,
    maxFlexiLoanAmount
}: {
    intl: IntlShape;
    values: TFormData;
    maxFlexiLoanAmount: number;
}) => {
    let errors = {};

    if (!values.turnover) {
        errors = _.setWith(
            errors,
            'turnover',
            intl.formatMessage(messages.turnoverValidation)
        );
    }

    if (!values.amount) {
        errors = _.setWith(
            errors,
            'amount',
            intl.formatMessage(messages.requestedAmountMissing)
        );
    }

    if (values.amount < MINIMUM_FLEXI_LOAN_AMOUNT) {
        errors = _.setWith(
            errors,
            'amount',
            intl.formatMessage(messages.requestedAmountTooLow, {
                minAmount: intlFormatCurrency({
                    intl,
                    value: MINIMUM_FLEXI_LOAN_AMOUNT
                })
            })
        );
    }
    if (values.amount > maxFlexiLoanAmount) {
        errors = _.setWith(
            errors,
            'amount',
            intl.formatMessage(messages.requestedAmountTooHigh, {
                maxAmount: intlFormatCurrency({
                    intl,
                    value: maxFlexiLoanAmount
                })
            })
        );
    }

    if (!values.purpose) {
        errors = _.setWith(
            errors,
            'purpose',
            intl.formatMessage(messages.loanPurposeValidation)
        );
    }

    if (getCountry() === 'DE' && !values.duration) {
        errors = _.setWith(
            errors,
            'duration',
            intl.formatMessage(messages.loanDurationValidation)
        );
    }

    return errors;
};
